import React, { createContext, useContext, useCallback, useMemo } from 'react';

const translations = {
  fr: {
    // Sidebar
    'nav.dashboard': 'Tableau de bord',
    'nav.validate': 'Valider les heures',
    'nav.planning': 'Planning',
    'nav.employees': 'Gestion des Salaries',
    'nav.documents': 'ADMINISTRATION',
    'nav.projects': 'Gestion des Chantiers',
    'nav.expenses': 'Depenses',
    'nav.employee_expenses': 'Notes de frais',
    'nav.vat': 'TVA',
    'nav.resources': 'Ressources & Equipements',
    'nav.chat': 'Chat equipe',
    'nav.reports': 'Rapports',
    'nav.history': 'Historique',
    'nav.settings': 'Personnalisation',
    'nav.time_entry': 'Saisir mes heures',
    'nav.my_hours': 'Mes heures',
    'nav.logout': 'Deconnexion',
    'nav.my_projects': 'Mes chantiers',
    'nav.leaves_absences': 'Conges et Absence',
    'nav.my_documents': 'Mes documents',
    // Roles
    'role.admin': 'Administrateur',
    'role.employee': 'Employe',
    // Pages headers
    'page.dashboard': 'Tableau de bord',
    'page.dashboard_sub': 'Vue d\'ensemble de l\'activite',
    'page.validate': 'Validation des heures',
    'page.validate_sub': 'Validez les heures des employes',
    'page.planning': 'Planning',
    'page.planning_sub': 'Planification des chantiers',
    'page.employees': 'Gestion des Salaries',
    'page.employees_sub': 'Salaries, documents, conges et absences',
    'page.documents': 'ADMINISTRATION',
    'page.documents_sub': 'Salaries, conges, validation et documents',
    'page.projects': 'Gestion des Chantiers',
    'page.projects_sub': 'Chantiers, facturation, commandes et documents',
    'page.expenses': 'Depenses',
    'page.expenses_sub': 'Suivi des depenses',
    'page.employee_expenses': 'Notes de frais',
    'page.employee_expenses_sub': 'Gerez vos notes de frais',
    'page.vat': 'Synthese TVA',
    'page.vat_sub': 'Suivi et export TVA',
    'page.resources': 'Ressources & Equipements',
    'page.resources_sub': 'Stocks, materiel et vehicules',
    'page.chat': 'Chat d\'equipe',
    'page.chat_sub': 'Communiquez avec votre equipe en temps reel',
    'page.reports': 'Rapports',
    'page.reports_sub': 'Rapports et statistiques',
    'page.history': 'Historique',
    'page.history_sub': 'Historique des modifications',
    'page.settings': 'Personnalisation',
    'page.settings_sub': 'Parametres de l\'application',
    'page.time_entry': 'Saisir mes heures',
    'page.time_entry_sub': 'Enregistrez vos heures de travail',
    'page.my_hours': 'Mes heures',
    'page.my_hours_sub': 'Consultez vos heures saisies',
    // Resources tabs
    'tab.stock': 'Gestion des stocks',
    'tab.equipment': 'Materiel',
    'tab.vehicles': 'Vehicules',
    // Employees tabs
    'tab.employees_list': 'Salaries',
    'tab.employee_docs': 'Documents',
    'tab.leaves': 'Conges',
    'tab.absences': 'Arrets & Absences',
    // Projects tabs
    'tab.projects_list': 'Chantiers',
    'tab.invoicing': 'Facturation',
    'tab.shopping': 'Liste de courses',
    'tab.orders': 'Commandes a faire',
    'tab.project_docs': 'Documents de chantier',
    // Finance tabs
    'tab.expenses': 'Depenses',
    'tab.employee_expenses': 'Notes de frais',
    'tab.vat': 'TVA',
    'page.finance': 'Finances',
    'page.finance_sub': 'Depenses, notes de frais et TVA',
    'nav.finance': 'Finances',
    // Chat
    'chat.connected': 'Connecte',
    'chat.reconnecting': 'Reconnexion...',
    'chat.typing_one': 'ecrit...',
    'chat.typing_many': 'ecrivent...',
    'chat.placeholder': 'Ecrivez votre message...',
    'chat.no_messages': 'Aucun message. Commencez la conversation !',
    'chat.send_error': "Erreur lors de l'envoi",
    // Common
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.add': 'Ajouter',
    'common.search': 'Rechercher',
    'common.filter': 'Filtrer',
    'common.export': 'Exporter',
    'common.loading': 'Chargement...',
    'common.no_data': 'Aucune donnee',
    'common.confirm': 'Confirmer',
    'common.back': 'Retour',
    'common.actions': 'Actions',
    'common.status': 'Statut',
    'common.date': 'Date',
    'common.name': 'Nom',
    'common.all': 'Tous',
    'common.new': 'Nouveau',
    'common.user': 'Utilisateur',
    'common.notifications': 'Notifications',
    'common.mark_all_read': 'Tout lire',
    'common.no_notifications': 'Aucune notification',
  },
  en: {
    // Sidebar
    'nav.dashboard': 'Dashboard',
    'nav.validate': 'Validate Hours',
    'nav.planning': 'Planning',
    'nav.employees': 'Employee Management',
    'nav.documents': 'ADMINISTRATION',
    'nav.projects': 'Site Management',
    'nav.expenses': 'Expenses',
    'nav.employee_expenses': 'Expense Reports',
    'nav.vat': 'VAT',
    'nav.resources': 'Resources & Equipment',
    'nav.chat': 'Team Chat',
    'nav.reports': 'Reports',
    'nav.history': 'History',
    'nav.settings': 'Settings',
    'nav.time_entry': 'Log My Hours',
    'nav.my_hours': 'My Hours',
    'nav.logout': 'Logout',
    'nav.my_projects': 'My Sites',
    'nav.leaves_absences': 'Leaves & Absences',
    'nav.my_documents': 'My Documents',
    // Roles
    'role.admin': 'Administrator',
    'role.employee': 'Employee',
    // Pages headers
    'page.dashboard': 'Dashboard',
    'page.dashboard_sub': 'Activity overview',
    'page.validate': 'Hours Validation',
    'page.validate_sub': 'Validate employee hours',
    'page.planning': 'Planning',
    'page.planning_sub': 'Site planning',
    'page.employees': 'Employee Management',
    'page.employees_sub': 'Employees, documents, leaves and absences',
    'page.documents': 'ADMINISTRATION',
    'page.documents_sub': 'Employees, leaves, validation and documents',
    'page.projects': 'Site Management',
    'page.projects_sub': 'Sites, invoicing, orders and documents',
    'page.expenses': 'Expenses',
    'page.expenses_sub': 'Expense tracking',
    'page.employee_expenses': 'Expense Reports',
    'page.employee_expenses_sub': 'Manage your expense reports',
    'page.vat': 'VAT Summary',
    'page.vat_sub': 'VAT tracking and export',
    'page.resources': 'Resources & Equipment',
    'page.resources_sub': 'Stock, equipment and vehicles',
    'page.chat': 'Team Chat',
    'page.chat_sub': 'Communicate with your team in real time',
    'page.reports': 'Reports',
    'page.reports_sub': 'Reports and statistics',
    'page.history': 'History',
    'page.history_sub': 'Modification history',
    'page.settings': 'Settings',
    'page.settings_sub': 'Application settings',
    'page.time_entry': 'Log My Hours',
    'page.time_entry_sub': 'Record your working hours',
    'page.my_hours': 'My Hours',
    'page.my_hours_sub': 'View your logged hours',
    // Resources tabs
    'tab.stock': 'Stock Management',
    'tab.equipment': 'Equipment',
    'tab.vehicles': 'Vehicles',
    // Employees tabs
    'tab.employees_list': 'Employees',
    'tab.employee_docs': 'Documents',
    'tab.leaves': 'Leaves',
    'tab.absences': 'Absences & Sick Leave',
    // Projects tabs
    'tab.projects_list': 'Sites',
    'tab.invoicing': 'Invoicing',
    'tab.shopping': 'Shopping List',
    'tab.orders': 'Orders',
    'tab.project_docs': 'Site Documents',
    // Finance tabs
    'tab.expenses': 'Expenses',
    'tab.employee_expenses': 'Expense Reports',
    'tab.vat': 'VAT',
    'page.finance': 'Finance',
    'page.finance_sub': 'Expenses, expense reports and VAT',
    'nav.finance': 'Finance',
    // Chat
    'chat.connected': 'Connected',
    'chat.reconnecting': 'Reconnecting...',
    'chat.typing_one': 'is typing...',
    'chat.typing_many': 'are typing...',
    'chat.placeholder': 'Write your message...',
    'chat.no_messages': 'No messages yet. Start the conversation!',
    'chat.send_error': 'Error sending message',
    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.add': 'Add',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.export': 'Export',
    'common.loading': 'Loading...',
    'common.no_data': 'No data',
    'common.confirm': 'Confirm',
    'common.back': 'Back',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.name': 'Name',
    'common.all': 'All',
    'common.new': 'New',
    'common.user': 'User',
    'common.notifications': 'Notifications',
    'common.mark_all_read': 'Mark all read',
    'common.no_notifications': 'No notifications',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Application 100% francaise - langue forcee
  const language = 'fr';
  const setLanguage = () => {};

  const t = useCallback((key) => {
    return translations['fr']?.[key] || key;
  }, []);

  const langValue = useMemo(() => ({ language, setLanguage, t }), [t]);

  return (
    <LanguageContext.Provider value={langValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { language: 'fr', t: (k) => k, setLanguage: () => {} };
  return ctx;
};
